export const API_URL = "https://plesh-remote-multi-user-api-y2qbyk5t3a-ew.a.run.app/"
//export const API_URL = "http://localhost:8080/"
//export const TOOLPRESS_API = "https://api-tool-press-yn26wrnl4q-ey.a.run.app"
export const TOOLPRESS_API = "https://toolpress-api.2ndstage.app"

export const THEME_CONFIG = {
    mode:"dark",
    gradients: {
        default: ['#E45549', '#E45549'],
        home_question: ['#5F9B61', '#5F9B61'],
    },
    borders : {
        default: 'none',
        home_question: 'none'
    },
    borderRadius: {
        default: '25px',
        photo: '0rem',
        textField: '25px',
    },
    shadows : {
        default: 'none',
        home_question: 'none'
    },

    agendaStyle : {
        headerColor: '#EA4D95',
        boxShadow: '0px 8px 10px 0px rgba(0,0,0,0.2)',
        borderRadius: '0px',
        headerTextColor: '#fff',
        contentTextColor: '#fff',
        iconColor: '#fff',
        backgroundColor: '#2e1344',
    },

    agendaViewStyle : {
        todayHeaderBkgColor: '#EA4D95',
        headerBkgColor: '#1c0b28',
        todayTitleColor: '#fff',
        titleColor: '#fff',
        timesColor: '#fff',
        textColor: '#fff',
        accordionBkgColor: '#2e1344'
    },

    primary: '#fff',
    secondary: '#fff',
    accent: '#fff',
    text: '#eceff1',
    buttonText: {
        home_question: '#fff',
        default: '#fff'
    },
    background:"#fef8f1",

    homeQuestionIcon: false,

    poll:{
        default:"#fff",
        answered:"#E4D0A7",
        correct: '#5F9B61',
        wrong: '#E45549'
    },
    pollBorder: {
        default:"#000",
        answered:"#000",
        correct: '#000',
        wrong: '#000'
    },
    pollTextColor: {
        default:"#000",
        answered:"#000",
        correct: '#fff',
        wrong: '#8C312A'
    }
}